import { GenericBaseParameter } from '../base-parameter';

export interface IDemandProposalParameterModel {

}
export class DemandProposalParameterModel extends GenericBaseParameter<IDemandProposalParameterModel> implements IDemandProposalParameterModel {

  /**
   *
   */
  constructor(option: IDemandProposalParameterModel) {
    super();
    Object.keys(option).forEach(key => this[key] = option[key]);
  }
}